import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid, } from 'uuid';
import Label from './Label';

class VerticalLabelList extends React.Component {
  static toList = (obj, options = {}) => {
    const { displayFormatter = value => value, } = options;
    const keys = Object.keys(obj);
    const items = keys.map((key) => {
      const data = obj[key];
      return {
        label: {
          display: displayFormatter(key),
          value: key,
        },
        data: {
          display: data,
          value: data,
        },
      };
    });
    return items;
  };

  format(items) {
    const { exclusions, } = this.props;
    if (!items || items.length === 0) {
      return null;
    }
    return items
      .filter((item) => {
        const { label, } = item;
        return !exclusions.includes(label.value);
      })
      .map((item) => {
        const { label, data, } = item;
        return <Label key={uuid()} label={label} data={data} />;
      });
  }

  render() {
    const { items, } = this.props;
    return <div className="container small">{this.format(items)}</div>;
  }
}

VerticalLabelList.defaultProps = {
  exclusions: [],
};
VerticalLabelList.propTypes = {
  items: PropTypes.array.isRequired,
  exclusions: PropTypes.array,
};

export default VerticalLabelList;
